import { render, staticRenderFns } from "./ShareIndex.vue?vue&type=template&id=1f05d45a"
import script from "./ShareIndex.vue?vue&type=script&lang=js"
export * from "./ShareIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports